module.exports = __webpack_public_path__ + "img/choose.f3426ee3.svg";